import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { GebruikPlek, onderdeelVan } from '../helpers/gebruik-onderdeel';
import { AuthService } from './auth.service';
import { NO_ERROR_TOKEN } from '../interceptors/error.interceptor';

/**
 * Meldt elke minuut welk onderdeel open staat (Stats, rapport, wedstrijd,
 * live, spelers, taggen), voor het weekoverzicht "wie gebruikte wat,
 * wanneer" in de beheerconsole (15-10-2026). Alleen als het venster
 * zichtbaar is en iemand is ingelogd. Een fout doet niets: dit mag het
 * gebruik nooit hinderen.
 */
@Injectable({ providedIn: 'root' })
export class GebruikMeldingService {
  private static readonly ELKE_MINUUT = 60_000;
  private plek: GebruikPlek | null = null;
  private gestart = false;

  constructor(
    private http: HttpClient,
    private router: Router,
    private authService: AuthService,
    private zone: NgZone,
  ) {}

  start(): void {
    if (this.gestart || typeof window === 'undefined') {
      return;
    }
    this.gestart = true;
    this.plek = onderdeelVan(this.router.url);
    this.router.events.pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd)).subscribe((e) => {
      const nieuw = onderdeelVan(e.urlAfterRedirects);
      const anders = nieuw?.area !== this.plek?.area || nieuw?.ref !== this.plek?.ref;
      this.plek = nieuw;
      if (anders) {
        this.meld();
      }
    });
    // Buiten Angular: een timer per minuut hoeft geen schermen te verversen.
    this.zone.runOutsideAngular(() => setInterval(() => this.meld(), GebruikMeldingService.ELKE_MINUUT));
  }

  private meld(): void {
    const plek = this.plek;
    if (!plek || !this.authService.token || document.visibilityState !== 'visible') {
      return;
    }
    // Zonder foutmelding of uitloggen bij een fout: dat doen de echte verzoeken wel.
    const context = new HttpContext().set(NO_ERROR_TOKEN, true);
    this.http.put(`${environment.apiUrl}/Monitoring/Activity`, { area: plek.area, ref: plek.ref }, { context }).subscribe({ error: () => {} });
  }
}
